module.exports = [
  require('./orc_blade_of_ilneval'),
  require('./orc_claw_of_luthic'),
  require('./orc_hand_of_yurtrus'),
  require('./orc_nurtured_one_of_yurtrus'),
  require('./orc_red_fang_of_shargaas'),
  require('./ox'),
]
